import { useSelector } from 'react-redux';
import { RootState } from 'common/store/types';

export interface FeatureFlags {
  [flagName: string]: boolean;
}

const defaultFeatureFlagValue: Readonly<FeatureFlags> = {};

export function useFeatureFlags(): FeatureFlags {
  return useSelector<RootState, FeatureFlags>(
    state => state.featureFlags || defaultFeatureFlagValue
  );
}

export function useFeatureFlag(flagName: string): boolean {
  const featureFlags = useFeatureFlags();

  if (Object.prototype.hasOwnProperty.call(featureFlags, flagName)) {
    return featureFlags[flagName];
  }

  return false;
}
